/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationResponseDto } from '../models/NotificationResponseDto';
import type { SendAnnouncementDto } from '../models/SendAnnouncementDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssociationAnnouncementsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Send announcement to association members
   * @returns NotificationResponseDto
   * @throws ApiError
   */
  public sendAnnouncementToAssociation({
    requestBody,
  }: {
    requestBody: SendAnnouncementDto,
  }): CancelablePromise<NotificationResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/association/{associationId}/announcements',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
